class ReleaseCalendar extends HTMLElement {
  constructor() {
    super();

    this.timezone = this.getAttribute('data-timezone');
    this.serverTime = parseInt(this.getAttribute('data-server-time'));

    this.localeUrl = '';
    if (window.theme.locale === 'fr') {
      localeUrl = '/fr';
    }

    this.articles = JSON.parse(
      document.getElementById('ReleaseCalendarArticles').textContent
    );
    this.indexArticle = 0;
    this.lastIndex = this.articles.length;

    this.init();
  }

  init() {
    this.articles.map((article) => this.getArticle(article));
  }

  getArticle(article) {
    return fetch(
      `/blogs/release-calendar/${article.handle}?section_id=release-calendar_data`
    )
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const data = JSON.parse(
          html.getElementById('ReleaseCalendarData').textContent
        );

        this.setArticle(data);
      });
  }

  setArticle(data) {
    let product = data.product;
    let article = data.article;
    let accentuate = data.accentuate;
    let price = accentuate.price
      ? window.theme.locale === 'fr'
        ? `: ${accentuate.price}$ CAD`
        : `: $${accentuate.price} CAD`
      : '';
    let style = accentuate.style_
      ? `<span>Style</span>: ${accentuate.style_}`
      : '';

    let today = new Date(this.serverTime);
    let action = this.getActionType(accentuate, product, today);

    if (
      accentuate.pin_product_to_featured == 'true' &&
      (accentuate.this_product_is_released_first == 'true' ||
        accentuate.this_product_is_getting_raffle == 'true')
    ) {
      let e = document.createElement('div');

      let feature_item = `
        <li id="Slide-${article.id}" class='grid__item slider__slide'>
          <div class="release__featured-item release__product">        
            <div class='media media--square'>
              <img src="${article.image.src}" alt="${article.title}" />
            </div>
            <h3 class='release__featured-title'>${article.title}</h3>
            <div class="featured__item-details">
              <div class="featured__item-info">
                ${style}
                ${
                  accentuate.price && accentuate.style_ ? '|' : ''
                } <span>Price</span> ${price}
              </div>
              ${action.button ? action.button : ''}
              ${
                accentuate.display_launch_details === 'true'
                  ? `
                <modal-opener
                  class="featured__item-toggle"
                  data-modal="#FeaturedItemModal-${article.id}"
                >
                  <button class="link link--underlined">View launch details</button>
                </modal-opener>

                <modal-dialog id="FeaturedItemModal-${
                  article.id
                }" class="modal">
                  <div
                    role="dialog"
                    aria-label="${article.title}"
                    aria-modal="true"
                    class="modal__container modal__container--small"
                    tabindex="-1"
                  >
                    <button
                      id="ModalClose-${article.id}"
                      type="button"
                      class="link modal__close"
                      aria-label="Close"
                    >
                      X
                    </button>
                    <div class="modal__content">
                      <div class='launch_details-modal'>
                        <h2>Launch details</h2>
                        ${
                          accentuate.launch_details_fr &&
                          window.location.pathname.includes('/fr')
                            ? accentuate.launch_details_fr
                            : accentuate.launch_details
                        }
                        ${action.button ? action.button : ''}
                      </div>
                    </div>
                  </div>
                </modal-dialog>
                `
                  : ''
              }
            </div>
          </div>
        </li>`;

      e.innerHTML = feature_item;

      document
        .querySelector('[data-featured-items]')
        .appendChild(e.querySelector('li'));
    }

    let f = document.createElement('div');
    let list_item = `
      <li 
        id="Slide-${article.id}"
        class="grid__item slider__slide release__item release__product ${
          action.closed_raffle
        }">   
        <div class="release__item-wrapper">  
          <div class="release__item-image-wrapper">
            <div class='media media--square'>
              <img src="${article.image.src}" alt="${article.title}" />
            </div>
          </div>
          <div class="release__item-row">
            <div class="release__item-details">
              <div class='release__item-info-wrapper'>
                <h3 class="release__item-title">${article.title}</h3>
                <div class="release__item-info">
                  ${style} ${
      accentuate.price && accentuate.style_ ? '|' : ''
    } <span>Price</span>  ${price}
                </div>
              </div>
              <div class='release__item-info-wrapper'>
                ${action.button}
                ${
                  accentuate.display_launch_details === 'true'
                    ? `
                  <modal-opener
                  class="featured__item-toggle"
                  data-modal="#FeaturedItemModal-${article.id}"
                >
                  <button class="link link--underlined">View launch details</button>
                </modal-opener>

                <modal-dialog id="FeaturedItemModal-${
                  article.id
                }" class="modal">
                  <div
                    role="dialog"
                    aria-label="${article.title}"
                    aria-modal="true"
                    class="modal__container modal__container--small"
                    tabindex="-1"
                  >
                    <button
                      id="ModalClose-${article.id}"
                      type="button"
                      class="link modal__close"
                      aria-label="Close"
                    >
                      X
                    </button>
                    <div class="modal__content">
                      <div class='launch_details-modal'>
                        <h2>Launch details</h2>
                        ${
                          accentuate.launch_details_fr &&
                          window.location.pathname.includes('/fr')
                            ? accentuate.launch_details_fr
                            : accentuate.launch_details
                        }
                        ${action.button ? action.button : ''}
                      </div>
                    </div>
                  </div>
                </modal-dialog>
                  `
                    : ''
                }
              </div>
            </div>
          </div>
        </div>
      </li>`;

    f.innerHTML = list_item;

    if (!action.date_id) {
      let element = document.querySelector('[data-tbd-wrapper]');
      element.style.display = 'block';
      document
        .querySelector('[data-tbd-items]')
        .appendChild(f.querySelector('li'));
    } else if (action.date_id && action.button) {
      let d = action.date_id.split('-');
      let date = `${d[1]}/${d[0]}/${d[2]}`;
      let release = new Date(date);

      if (!this.isValidDate(release)) {
        release = new Date(date.replace(/-/g, '/'));
      }

      release.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      if (release < today && !accentuate.this_product_is_getting_raffle) {
        let element = document.querySelector('[data-released-wrapper]');
        element.style.display = 'block';

        const li = f.querySelector('li');
        document.querySelector('[data-released-items]').appendChild(li);
      } else if (release >= today) {
        let parent_list = this.manageArticleList(release, date);
        document.querySelector(parent_list).appendChild(f.querySelector('li'));
      }
    }

    if (this.indexArticle === this.lastIndex - 1) {
      const hasMultipleFeaturedItems =
        document.querySelectorAll('[data-featured-items] > *').length > 1;
      const hasMultipleReleasedItems =
        document.querySelectorAll('[data-released-items] > *').length > 1;

      if (hasMultipleFeaturedItems) {
        this.initiateReleasedSlider('[data-featured-items]');
      }

      if (hasMultipleReleasedItems) {
        this.initiateReleasedSlider('[data-released-items]');
      }
    }

    this.indexArticle++;
  }

  initiateReleasedSlider(selector) {
    const slider = document.querySelector(selector);
    const sliderComponent = slider.closest('slider-component');
    sliderComponent.init();
  }

  isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  }

  manageArticleList(date, data_id) {
    let days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    let date_id = `<span>${days[date.getDay()]} </span> ${
      date.getMonth() + 1
    }/${date.getDate()}`;

    let current_lists = document.querySelectorAll('[data-dated-wrapper]');

    let f = document.createElement('div');
    let new_list = `
      <div class="release__list" data-dated-wrapper=${data_id}>
        <h2 class="release__item-heading">${date_id}</h2>
        <ul data-dated-items=${data_id} class="grid grid--1-col"></ul>
      </div>`;
    f.innerHTML = new_list;

    if (current_lists.length < 1) {
      document.querySelector('[data-featured-items-wrapper]').after(f);
      return `[data-dated-items="${data_id}"]`;
    } else if (current_lists.length >= 1) {
      let dates = [];

      current_lists.forEach(function (index) {
        dates.push(index.dataset.datedWrapper);
      });

      if (dates.includes(data_id)) {
        return `[data-dated-items="${data_id}"]`;
      } else {
        dates.push(data_id);
        let sorted_dates = dates.sort(function (a, b) {
          return new Date(a) - new Date(b);
        });

        let current_index = sorted_dates.indexOf(data_id);
        let target_element =
          current_index - 1 != -1
            ? `[data-dated-wrapper="${sorted_dates[current_index - 1]}"]`
            : '[data-featured-items-wrapper]';

        document.querySelector(target_element).after(f);
        return `[data-dated-items="${data_id}"]`;
      }
    }
  }

  getActionType(accentuate, product, today) {
    let action = {};
    let release_time = false;

    if (
      accentuate.this_product_is_released_first == 'true' &&
      accentuate.release_time_ &&
      accentuate.release_day
    ) {
      release_time = this.getFullTime(
        accentuate.release_time_,
        accentuate.release_day
      );
    } else if (accentuate.this_product_is_getting_raffle == 'true') {
      if (accentuate.raffle_close_day && accentuate.raffle_close_time) {
        release_time = this.getFullTime(
          accentuate.raffle_close_time,
          accentuate.raffle_close_day
        );
      }
    }

    if (accentuate.this_product_is_released_first) {
      if (accentuate.release_day && release_time < Date.now()) {
        if (product && product.handle) {
          if (product.available) {
            action.button = `<a href="${product.url}" class="button button--primary">Shop Now</a>`;
          } else {
            action.button = false;
          }
        } else {
          action.button = false;
        }
      } else {
        action.button = `<a href="${this.localeUrl}/pages/notification" class="button button--secondary">Notify Me</a>`;
      }

      if (accentuate.release_day) {
        action.date_id = accentuate.release_day;
      }
    } else if (accentuate.this_product_is_getting_raffle) {
      if (
        accentuate.raffle_close_day &&
        accentuate.raffle_open_day &&
        accentuate.raffle_close_time &&
        accentuate.raffle_open_time
      ) {
        let raffleUrl = accentuate.raffle_page_url;
        if (Theme.settings.locale === 'fr') {
          raffleUrl = accentuate.raffle_page_url_french;
        }
        let open_time = getFullTime(
          accentuate.raffle_open_time,
          accentuate.raffle_open_day
        );
        if (open_time <= today && release_time >= today) {
          action.button = `<a href="${raffleUrl}" target="_blank" class="btn">Enter Raffle</a>`;
        } else if (open_time <= today && release_time <= today) {
          action.button = `<a class="btn btn--disabled">Raffle Closed</a>`;
          action.closed_raffle = 'release__raffle-closed';
        } else {
          action.button = `<a href="${this.localeUrl}/pages/notification" class="button button--secondary">Notify Me</a>`;
        }
      } else {
        action.button = `<a href="${this.localeUrl}/pages/notification" class="button button--secondary">Notify Me</a>`;
      }

      if (accentuate.raffle_release_day) {
        action.date_id = accentuate.raffle_release_day;
      }
    }

    return action;
  }

  getProductStock(handle) {
    return graphQL(`{
       productByHandle(handle: "${handle}") {
           title
           totalInventory
           availableForSale
           onlineStoreUrl
         }
       }`);
  }

  getFullTime(time_string, day_string) {
    let d = day_string.split('-');
    let date = `${d[1]}/${d[0]}/${d[2]}`;
    let time = time_string.replace('pm', ' PM').replace('am', ' AM');

    let newDate = new Date(date + ' ' + time + ' ' + this.timezone);

    return newDate;
  }
}

customElements.define('release-calendar', ReleaseCalendar);
